import React, { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import sha256 from 'crypto-js/sha256';
import Cropper from 'react-easy-crop';



function PointageSelection() {
    const { t } = useTranslation();

    const apiUrl = process.env.REACT_APP_BACKEND_URL
    const ImageUrl = process.env.REACT_APP_IMAGES_URL
    const frontEndUrl = process.env.REACT_APP_REACT_URL

    let userId = Cookies.get('userId');
    let UserToken = Cookies.get('UserSpecialToken');
    let IdEntreprise = Cookies.get('IdEntreprise');
    let LanguageSelected = Cookies.get('LanguageSelected');

    const [PointageType, setPointageTyle] = useState('entry')
    const [entryid, setEntryid] = useState('')

    const hashedUserId = sha256((String(userId)));
    const [PointageModal, setPointageModal] = useState(false)

    const [isFetching, setIsFetching] = useState(false);

    const [PointageInfo, setPointageInfo] = useState({})

    const [Done, setDone] = useState(false)
    const [InputsErrors, setInputsErrors] = useState([])




    const AddingPointageInfo = (e) => {
        return setPointageInfo({ ...PointageInfo, [e.target.name]: e.target.value })

    }


    useEffect(() => {
        checkPointageType()
    }, [Done])

    const getLocation = async (e) => {
        e.preventDefault();

        const getCoordinates = (position) => {
            const { latitude, longitude } = position.coords;
            getAddressFromCoordinates(latitude, longitude, e);
        }

        const getAddressFromCoordinates = async (latitude, longitude, e) => {
            try {
                const response = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&zoom=18&addressdetails=1`);
                const data = await response.json();

                if (PointageType !== 'entry') {
                    SaveExit(e, data.display_name);
                } else {
                    SaveEntry(e, data.display_name);
                }
            } catch (error) {
                console.error('Error fetching address:', error);
            }
        }

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(getCoordinates);
        } else {
            console.error('Geolocation is not supported by this browser.');
        }
    }





    const checkPointageType = () => {
        fetch(`${apiUrl}/checkPointageType`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json", 'Authorization': `Bearer ${UserToken}`
            },
            body: JSON.stringify({ user_id: userId })
        })
            .then(response => response.json())
            .then(result => {
                setPointageTyle(result.type)
                setPointageInfo({ ...PointageInfo, entry_Id: result.entry })
            })
    }

    const SaveEntry = (e, address) => {
        e.preventDefault();
        setIsFetching(true);

        e.preventDefault()
        axios
            .post(`${apiUrl}/SaveEntryPointage`, { data: PointageInfo, location: address }, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${UserToken}`,
                },
            }).then(result => {
                if (result.data.success) {
                    setPointageInfo('')
                    setDone(!Done)
                    setInputsErrors([])
                    setImageToCrop(null)
                    setCroppedImage(null)
                    setCropImage(false)
                    setPointageModal(false)
                    setZoom(1)

                    toast.success(result.data.message, {
                        position: toast.POSITION.CENTER
                    });

                }
                else {
                    setInputsErrors(result.data.errors)

                }
            })
            .finally(() => {
                setIsFetching(false);
            });


    }
    const SaveExit = (e, address) => {
        e.preventDefault();
        setIsFetching(true);

        e.preventDefault()
        axios
            .post(`${apiUrl}/SaveExitPointage`, { data: PointageInfo, location: address }, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${UserToken}`,
                },
            }).then(result => {
                if (result.data.success) {
                    setPointageInfo('')
                    setDone(!Done)
                    setInputsErrors([])
                    setImageToCrop(null)
                    setCroppedImage(null)
                    setCropImage(false)
                    setPointageModal(false)
                    setZoom(1)

                    toast.success(result.data.message, {
                        position: toast.POSITION.CENTER
                    });

                }
                else {
                    setInputsErrors(result.data.errors)

                }
            })
            .finally(() => {
                setIsFetching(false);
            });


    }

    function compressImage(file) {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (event) => {
                const img = new Image();
                img.src = event.target.result;

                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    const maxWidth = 800; // Set your desired max width
                    const maxHeight = 600; // Set your desired max height
                    let newWidth = img.width;
                    let newHeight = img.height;

                    if (img.width > maxWidth || img.height > maxHeight) {
                        const aspectRatio = img.width / img.height;
                        if (aspectRatio > 1) {
                            newWidth = maxWidth;
                            newHeight = maxWidth / aspectRatio;
                        } else {
                            newHeight = maxHeight;
                            newWidth = maxHeight * aspectRatio;
                        }
                    }

                    canvas.width = newWidth;
                    canvas.height = newHeight;
                    ctx.drawImage(img, 0, 0, newWidth, newHeight);

                    canvas.toBlob((blob) => {
                        resolve(new File([blob], file.name, { type: file.type }));
                    }, file.type, 0.7); // Adjust compression quality here (0.7 = 70%)
                };
            };
            reader.readAsDataURL(file);
        });
    }

    const AddingPointageInfoImage = async (e) => {
        e.preventDefault()
        let Picture = e.target.files[0]
        if (!Picture) {
            toast.error('No image selected');
            return;
        }

        const allowedExtensions = ['png', 'jpg', 'jpeg', 'gif'];
        const maxSize = 20 * 1024 * 1024; // 20 MB in bytes

        const extension = Picture.name.split('.').pop().toLowerCase();
        if (!allowedExtensions.includes(extension)) {
            toast.error('Invalid image format. Allowed formats: PNG, JPG, JPEG, GIF');
            return;
        }

        if (Picture.size > maxSize) {
            toast.error('Image size exceeds 20 MB');
            return;
        }

        handleImageCrop(e, Picture)
    };

    const [CropImage, setCropImage] = useState(false);
    const [zoom, setZoom] = useState(1);
    const [croppedImage, setCroppedImage] = useState(null);
    const [crop, setCrop] = useState({ x: 0, y: 0 });

    useEffect(() => {
        if (PointageModal || CropImage) {
            document.body.classList.add('modal-open');
        } else {
            document.body.classList.remove('modal-open');
        }
    }, [PointageModal, CropImage]);


    const [imageToCrop, setImageToCrop] = useState(null);

    const onCropChange = (crop) => {
        setCrop(crop);
    };

    const onZoomChange = (zoom) => {
        setZoom(zoom);
    };



    const handleImageCrop = (e, fileImage) => {
        const file = fileImage;

        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                setImageToCrop(reader.result);
            };
            reader.readAsDataURL(file);
        }


        setCropImage(true);
    };

    const Base64Image = async () => {
        const croppedImageBase64 = await convertBlobToBase64(croppedImage);
        return setPointageInfo({ ...PointageInfo, Image: croppedImageBase64 });

    }

    const handleCropComplete = async (_, croppedAreaPixels) => {
        try {
            const croppedImageBlob = await getCroppedImageBlob(imageToCrop, croppedAreaPixels);
            const compressedFile = await compressImage(croppedImageBlob);
            setCroppedImage(compressedFile);

        } catch (error) {
            console.error('Error cropping image:', error);
        }
    };
    const convertBlobToBase64 = (blob) => {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.readAsDataURL(blob);
        });
    };


    const getCroppedImageBlob = (imageSrc, croppedAreaPixels) => {
        return new Promise((resolve) => {
            const image = new Image();
            image.src = imageSrc;
            const canvas = document.createElement('canvas');
            canvas.width = croppedAreaPixels.width;
            canvas.height = croppedAreaPixels.height;
            const ctx = canvas.getContext('2d');

            image.onload = () => {
                ctx.drawImage(
                    image,
                    croppedAreaPixels.x,
                    croppedAreaPixels.y,
                    croppedAreaPixels.width,
                    croppedAreaPixels.height,
                    0,
                    0,
                    croppedAreaPixels.width,
                    croppedAreaPixels.height
                );
                canvas.toBlob((blob) => {
                    resolve(blob);
                }, 'image/jpeg');
            };
        });
    };





    return (
        <div className='w-full'>
            <button onClick={() => setPointageModal(true)} type="submit" className="w-full font-semibold relative text-theme flex justify-start items-center mt-3 p-3 py-2 px-4 border border-transparent rounded shadow-sm text-sm font-medium text-black sections h-16  hover:bg-gold focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gold">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" className={`${LanguageSelected == 'ar' ? 'w-5 ml-3' : 'w-5 mr-3'}`}>
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                </svg>


                {t("Add Pointage")}

            </button>

            {PointageModal &&
                <div>

                    <div className="minscreen h-full animated fadeIn faster  fixed  left-0 top-0 flex justify-center items-center inset-0 z-50 forms-info ">
                        <div className="absolute top-0 right-0 p-4">
                            <a className='w-12 h-12' onClick={() => { setPointageModal(false); setCroppedImage(null); setImageToCrop(null); setInputsErrors([]) }}>
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                                </svg>
                            </a>
                        </div>
                        <div className="w-full max-w-sm  p-8  rounded-md">
                            <h2 className="text-3xl mb-2  text-theme">{t(`Pointage ${PointageType}`)} </h2>
                            <form className="space-y-6 text-about">
                                <div>
                                    <label htmlFor="image" className="textModal ">{t("Entrez les info de votre pointage")} </label>
                                    {croppedImage &&
                                        <div className='relative '>
                                            <div className='w-44 h-44'>
                                                <img className="cover w-full h-full preview-image  border rounded-xl mt-4" src={URL.createObjectURL(croppedImage)} alt="Preview" />

                                            </div>
                                            <a onClick={() => { setCroppedImage(null); setImageToCrop(null); }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 absolute right-1 top-1  text-white div-sections opacity-50 rounded-xl  cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                                                    <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                                                </svg>
                                            </a>
                                            <p className="mt-2 text-center  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('Image') && InputsErrors.Image}</span></p>

                                        </div>

                                    }

                                    <div className="flex items-center justify-center w-full">
                                        {!croppedImage &&
                                            <label htmlFor="dropzone-file-service" className="flex flex-col items-center justify-center w-full h-44 mt-5 border-2 border-gold border-dashed rounded-lg cursor-pointer div-sections  ">

                                                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                                    <svg aria-hidden="true" className="w-10 h-10 mb-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12">
                                                        </path>
                                                    </svg>
                                                    <center>                <p className="mb-2 text-sm text-gray-300 "><span className="font-semibold">{t("Cliquez pour télécharger pointage")}</span> </p>
                                                    </center>                <p className="text-xs text-gray-400 ">SVG, PNG, JPG or GIF (MAX.
                                                        800x400px)</p>
                                                    <p className="mt-2 text-center  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('Image') && InputsErrors.Image}</span></p>

                                                </div>

                                                <input
                                                    onChange={(e) => AddingPointageInfoImage(e)}
                                                    id="dropzone-file-service"
                                                    type="file"
                                                    accept="image/*"
                                                    capture="camera"
                                                    name="Image"
                                                    className="hidden"
                                                />

                                            </label>
                                        }
                                    </div>
                                    {/* <div className='mt-3'>
                                        <div className="mt-5">
                                            <input onChange={(e) => { AddingPointageInfo(e) }} type="text" id="location" name="location" className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("Entrer votre Location*")} required />
                                            <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('location') && InputsErrors.location}</span></p>

                                        </div>
                                    </div> */}
                                    {/* <div className='mt-3'>
                                        <div className="mt-5">
                                            <input onChange={(e) => { AddingPointageInfo(e) }} type="datetime-local" id="date" name="date" className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("Entrer la date*")} required />
                                            <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('date') && InputsErrors.date}</span></p>

                                        </div>
                                    </div> */}
                                    <div>
                                        <div className="mt-5">
                                            <textarea rows={5} onChange={(e) => { AddingPointageInfo(e) }} id="comment" name="comment" className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("Entrer votre commentaire")}  ></textarea>
                                            <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('comment') && InputsErrors.comment}</span></p>

                                        </div>
                                    </div>


                                </div>

                                <button onClick={(e) => getLocation(e)} disabled={isFetching} type="submit" className="w-full btn-edit">
                                    {isFetching ?
                                        (<svg class="w-6 h-6 text-white animate-spin" viewBox="0 0 64 64" fill="none"
                                            xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                                            <path
                                                d="M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z"
                                                stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path
                                                d="M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762"
                                                stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" class="text-gray-900">
                                            </path>
                                        </svg>)
                                        : (
                                            PointageType == 'entry' ? t('enregistrer entry') : t('enregistrer exit')
                                        )
                                    }
                                </button>



                            </form></div>
                    </div>
                </div>


            }

            {CropImage &&
                <div>
                    <div className="minscreen overflow-auto h-full animated fadeIn faster fixed left-0 top-0 flex justify-center items-center inset-0 z-1000 forms-info">
                        <div className="absolute top-0 right-0 p-4">
                            <a className='w-12 h-12' onClick={() => {
                                setCropImage(false); setCroppedImage(null);
                                setImageToCrop(null);
                                setZoom(1)

                            }}>
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                                </svg>
                            </a>
                        </div>
                        <div className="w-full text-about settingswidth p-8">
                            <div className="flex flex-col items-left justify-start mt-8">
                                <p className="text-md text-gold ">
                                    {t("Recadrez votre photo pour un meilleur rendu")}
                                </p>
                            </div>


                            <div className='flex flex-col items-center justify-center p-6'>
                                {imageToCrop && (
                                    <div className=" crop-container w-full ">
                                        <Cropper
                                            image={imageToCrop}
                                            crop={crop}
                                            zoom={zoom}
                                            aspect={4 / 4}
                                            onCropChange={onCropChange}
                                            onZoomChange={onZoomChange}
                                            onCropComplete={handleCropComplete}
                                        />
                                    </div>
                                )}
                                <div className=" controls">
                                    <label for="zoom-input" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Zoom : </label>
                                    <input id="zoom-input" type="range"
                                        min={1}
                                        max={3}
                                        step={0.1}
                                        value={zoom}
                                        onChange={(e) => onZoomChange(parseFloat(e.target.value))}
                                        className="w-full h-2 mb-6 bg-gray-200 rounded-lg appearance-none cursor-pointer text-gold" />

                                </div>
                                {croppedImage && (
                                    <div className=" cropped-image-container">
                                        <div className="flex flex-col items-left justify-start mt-2 mb-4">
                                            <p className="text-md text-gold ">
                                                {t("Image Recadrer")}
                                            </p>
                                        </div>
                                        <div className='crop-image'>
                                            <img src={URL.createObjectURL(croppedImage)} alt="Cropped" />

                                        </div>
                                    </div>
                                )}
                            </div>



                            <div>
                                <button
                                    onClick={(e) => { setCropImage(false); Base64Image() }}
                                    type="submit"
                                    className="w-full btn-edit"
                                >
                                    {t("enregistrer")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            }

        </div>
    )
}

export default PointageSelection